import { usePageStore } from '@/store'
export function asyncData() {
    const pageStore = usePageStore(this.$pinia)
    return Promise.all([
        pageStore.getAgentInfo(this.agent_id),
        pageStore.getCompanyInfo()
    ]);
}
